export const fontFamily = {
	header: "MelindaScript",
	body: "Sailec",
}
